import React from 'react';
import ReactFlow, { 
  Background, 
  Controls, 
  MiniMap,
  Handle,
  Position,
  MarkerType
} from 'reactflow';
import 'reactflow/dist/style.css';

const IntellectualPropertyProtection = () => {
  const nodes = [
    {
      id: '1',
      type: 'input',
      data: { 
        label: (
          <div style={{ padding: '10px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>🛡️ IP Protection Overview</strong>
            <div style={{ fontSize: '12px', marginTop: '5px', color: '#666' }}>
              Safeguarding Innovation in EvoML & Artemis
            </div>
          </div>
        )
      },
      position: { x: 400, y: 0 },
      style: {
        background: '#f0f4f8',
        border: '2px solid #2196F3',
        borderRadius: '8px',
        width: 300
      }
    },
    
    // EvoML Section
    {
      id: 'evoml-main',
      data: { 
        label: (
          <div style={{ padding: '10px', textAlign: 'center' }}>
            <strong>🔬 EvoML Platform</strong>
            <div style={{ fontSize: '12px', marginTop: '5px' }}>
              Proprietary ML Technology
            </div>
          </div>
        )
      },
      position: { x: 100, y: 120 },
      style: {
        background: '#e3f2fd',
        border: '2px solid #1976D2',
        borderRadius: '8px',
        width: 200
      }
    },
    {
      id: 'evoml-algo',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Algorithm Protection</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Proprietary optimization algorithms</li>
              <li>Custom feature engineering methods</li>
              <li>Ensemble techniques</li>
              <li>Model selection strategies</li>
            </ul>
          </div>
        )
      },
      position: { x: 20, y: 240 },
      style: {
        background: '#ffffff',
        border: '1px solid #64B5F6',
        borderRadius: '6px',
        width: 250
      }
    },
    {
      id: 'evoml-code',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Source Code Protection</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Obfuscated core libraries</li>
              <li>Encrypted model artifacts</li>
              <li>Secure API endpoints</li>
              <li>Licensed SDK distribution</li>
            </ul>
          </div>
        )
      },
      position: { x: 20, y: 380 },
      style: {
        background: '#ffffff',
        border: '1px solid #64B5F6',
        borderRadius: '6px',
        width: 250
      }
    },
    
    // Artemis Section
    {
      id: 'artemis-main',
      data: { 
        label: (
          <div style={{ padding: '10px', textAlign: 'center' }}>
            <strong>⚡ Artemis Engine</strong>
            <div style={{ fontSize: '12px', marginTop: '5px' }}>
              Advanced Code Evolution
            </div>
          </div>
        )
      },
      position: { x: 600, y: 120 },
      style: {
        background: '#fff3e0',
        border: '2px solid #F57C00',
        borderRadius: '8px',
        width: 200
      }
    },
    {
      id: 'artemis-tech',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Evolution Technology</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Genetic programming algorithms</li>
              <li>AST manipulation techniques</li>
              <li>Fitness evaluation methods</li>
              <li>Multi-objective optimization</li>
            </ul>
          </div>
        )
      },
      position: { x: 530, y: 240 },
      style: {
        background: '#ffffff',
        border: '1px solid #FFB74D',
        borderRadius: '6px',
        width: 250
      }
    },
    {
      id: 'artemis-patents',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Patent Portfolio</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Code evolution methods</li>
              <li>Test generation algorithms</li>
              <li>Performance optimization techniques</li>
              <li>Language-agnostic transformation</li>
            </ul>
          </div>
        )
      },
      position: { x: 530, y: 380 },
      style: {
        background: '#ffffff',
        border: '1px solid #FFB74D',
        borderRadius: '6px',
        width: 250
      }
    },
    
    // Shared Protection Measures
    {
      id: 'shared-measures',
      data: { 
        label: (
          <div style={{ padding: '10px', textAlign: 'center' }}>
            <strong>🔐 Shared Protection Measures</strong>
          </div>
        )
      },
      position: { x: 350, y: 520 },
      style: {
        background: '#f3e5f5',
        border: '2px solid #7B1FA2',
        borderRadius: '8px',
        width: 200
      }
    },
    {
      id: 'legal',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Legal Framework</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Comprehensive licensing agreements</li>
              <li>Non-disclosure agreements (NDAs)</li>
              <li>Terms of service enforcement</li>
              <li>IP assignment clauses</li>
            </ul>
          </div>
        )
      },
      position: { x: 50, y: 620 },
      style: {
        background: '#ffffff',
        border: '1px solid #BA68C8',
        borderRadius: '6px',
        width: 220
      }
    },
    {
      id: 'technical',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Technical Safeguards</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>API key authentication</li>
              <li>Usage monitoring & limits</li>
              <li>Watermarking generated code</li>
              <li>Audit trails & logging</li>
            </ul>
          </div>
        )
      },
      position: { x: 290, y: 620 },
      style: {
        background: '#ffffff',
        border: '1px solid #BA68C8',
        borderRadius: '6px',
        width: 220
      }
    },
    {
      id: 'operational',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <strong>Operational Security</strong>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Restricted source access</li>
              <li>Employee IP agreements</li>
              <li>Regular security audits</li>
              <li>Incident response plan</li>
            </ul>
          </div>
        )
      },
      position: { x: 530, y: 620 },
      style: {
        background: '#ffffff',
        border: '1px solid #BA68C8',
        borderRadius: '6px',
        width: 220
      }
    },
    
    // Best Practices
    {
      id: 'best-practices',
      data: { 
        label: (
          <div style={{ padding: '10px', textAlign: 'center' }}>
            <strong>✅ Best Practices for Users</strong>
          </div>
        )
      },
      position: { x: 350, y: 760 },
      style: {
        background: '#e8f5e9',
        border: '2px solid #388E3C',
        borderRadius: '8px',
        width: 200
      }
    },
    {
      id: 'user-guidelines',
      data: { 
        label: (
          <div style={{ padding: '8px' }}>
            <ul style={{ fontSize: '11px', textAlign: 'left', margin: '5px 0', paddingLeft: '15px' }}>
              <li>Respect licensing terms</li>
              <li>Protect API credentials</li>
              <li>Report suspicious activity</li>
              <li>Keep generated code secure</li>
              <li>Follow attribution requirements</li>
              <li>Avoid reverse engineering</li>
            </ul>
          </div>
        )
      },
      position: { x: 280, y: 860 },
      style: {
        background: '#ffffff',
        border: '1px solid #66BB6A',
        borderRadius: '6px',
        width: 340
      }
    }
  ];

  const edges = [
    {
      id: 'e1-2',
      source: '1',
      target: 'evoml-main',
      type: 'smoothstep',
      animated: true,
      style: { stroke: '#2196F3' }
    },
    {
      id: 'e1-3',
      source: '1',
      target: 'artemis-main',
      type: 'smoothstep',
      animated: true,
      style: { stroke: '#F57C00' }
    },
    {
      id: 'e2-4',
      source: 'evoml-main',
      target: 'evoml-algo',
      type: 'smoothstep'
    },
    {
      id: 'e2-5',
      source: 'evoml-main',
      target: 'evoml-code',
      type: 'smoothstep'
    },
    {
      id: 'e3-6',
      source: 'artemis-main',
      target: 'artemis-tech',
      type: 'smoothstep'
    },
    {
      id: 'e3-7',
      source: 'artemis-main',
      target: 'artemis-patents',
      type: 'smoothstep'
    },
    {
      id: 'e4-8',
      source: 'evoml-algo',
      target: 'shared-measures',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e5-8',
      source: 'evoml-code',
      target: 'shared-measures',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e6-8',
      source: 'artemis-tech',
      target: 'shared-measures',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e7-8',
      source: 'artemis-patents',
      target: 'shared-measures',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e8-9',
      source: 'shared-measures',
      target: 'legal',
      type: 'smoothstep'
    },
    {
      id: 'e8-10',
      source: 'shared-measures',
      target: 'technical',
      type: 'smoothstep'
    },
    {
      id: 'e8-11',
      source: 'shared-measures',
      target: 'operational',
      type: 'smoothstep'
    },
    {
      id: 'e9-12',
      source: 'legal',
      target: 'best-practices',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e10-12',
      source: 'technical',
      target: 'best-practices',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e11-12',
      source: 'operational',
      target: 'best-practices',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e12-13',
      source: 'best-practices',
      target: 'user-guidelines',
      type: 'smoothstep'
    }
  ];

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <div style={{ 
        background: 'white', 
        padding: '20px',
        borderBottom: '1px solid #e0e0e0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ margin: 0, fontSize: '24px', color: '#333' }}>
          🛡️ Intellectual Property Protection for EvoML & Artemis
        </h1>
        <p style={{ margin: '10px 0 0 0', color: '#666' }}>
          Comprehensive measures to protect proprietary technology and ensure secure usage
        </p>
      </div>
      
      <div style={{ width: '100%', height: 'calc(100% - 100px)' }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          fitView
          attributionPosition="bottom-left"
        >
          <Background color="#aaa" gap={16} />
          <Controls />
          <MiniMap 
            style={{
              height: 120,
              backgroundColor: '#f8f8f8'
            }}
            maskColor="rgb(50, 50, 50, 0.8)"
          />
        </ReactFlow>
      </div>
    </div>
  );
};

export default IntellectualPropertyProtection; 